module.exports = __webpack_public_path__ + "media/images/icons/cog-69977133f2ecd8e5b3adb3118bc461ca.svg";